import { Network, Token } from 'config/types'
import { RowMiddle } from 'layout/Components/Row'
import { useTranslation } from 'react-i18next'
import { useTokenSuspendedByPage } from 'state/app/hooks'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import { ModalProps } from 'UIKit/ModalV2'
import Text from 'UIKit/Text'
import TransText from 'UIKit/Text/TransText'
import ChainLogo from 'UIKit/TokenLogo/ChainLogo'
import { getBalanceTokenKey } from 'utils'
import { getNetworkInfo } from 'utils/network'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { useTokensWithSameCode } from '../hooks/useNetwork'
import { PAYMENT_MODAL_THEME, PaymentWrapOption, StylePaymentModal } from './styles'

const SelectNetworkByCurrencyModal: React.FC<
  ModalProps<{
    onSelectToken: (currency: Token) => void
    selectedToken: Token
    selectedNetwork: Network
    from: PaymentPageEnums
  }>
> = ({ onDismiss, data }) => {
  const { t } = useTranslation()
  const { selectedToken, onSelectToken, selectedNetwork, from } = data
  const sameCodeTokens = useTokensWithSameCode(selectedToken, from)
  const { disabledTokenMap } = useTokenSuspendedByPage(null, from)

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} title={t('Choose Network')} />
      <ModalBody minHeight="150px" maxHeight="70vh" overflowY="scroll" gap="12px">
        {(sameCodeTokens || []).map((token) => {
          const network = getNetworkInfo(token.network)?.network

          if (!network) return <></>

          return (
            <PaymentWrapOption
              selected={network?.code === selectedNetwork?.code}
              gap="8px"
              key={network.code}
              onClick={() => {
                onSelectToken(token)
                onDismiss()
              }}
              justifyContent="space-between"
            >
              <RowMiddle gap="8px">
                <ChainLogo
                  network={network.chainId}
                  width={32}
                  height={32}
                  style={{
                    background: '#000D2B',
                    borderRadius: '50%',
                  }}
                />
                <Text small bold>
                  {network.networkInfo.displayName}
                </Text>
              </RowMiddle>

              {disabledTokenMap[getBalanceTokenKey(token.network, token.code)] && (
                <TransText fontSize="12px" color="textAlt699" textAlign="right">
                  Suspended
                </TransText>
              )}
            </PaymentWrapOption>
          )
        })}
      </ModalBody>
    </StylePaymentModal>
  )
}

export default SelectNetworkByCurrencyModal
